import { Component, EventEmitter, Output } from '@angular/core';
import { ProjectInfoPropertyValueDef } from '../../constants/project-info-property-value-def';
import { ProjectModel } from '@project/model/project.model';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  standalone: false,
  selector: 'app-select-cable-fed-side-popup',
  templateUrl: './select-cable-fed-side.component.html'
})
export class SelectCableFedSidePopupComponent {

  public readonly cableFedSideTop: string = ProjectInfoPropertyValueDef.BUILDING_BLOCK_CABLE_FED_SIDE_TOP;
  public readonly cableFedSideBottom: string = ProjectInfoPropertyValueDef.BUILDING_BLOCK_CABLE_FED_SIDE_BOTTOM;

  @Output() public finish = new EventEmitter<void>();

  public selectedCableFedSide: string = ProjectInfoPropertyValueDef.BUILDING_BLOCK_CABLE_FED_SIDE_TOP;

  constructor(private bsModalRef: BsModalRef, private projectModel: ProjectModel) { }

  private setCableFedSide(): void {
    this.projectModel.currentInfoProperties.setString("buildingBlockCableFedSide", this.selectedCableFedSide);
  }

  public close(): void {
    this.setCableFedSide();
    this.bsModalRef.hide();
    this.finish.emit();
  }
}
